import { HttpHeaders, HttpRequest, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments';
import { variables } from '@shared/helper/configs';
import { GeneralService } from '@shared/services/general.service';
import { TokenService } from '@shared/services/token.service';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  let headers = req.headers;
  headers = handleXSourcePHeader(headers);
  headers = handleDidHeader(headers);
  headers = handleAccessTokenHeader(headers);
  headers = handleTmtTokenHeader(req, headers);
  headers = handleRefreshTokenHeader(req, headers);
  return next(req.clone({ headers }));
};

const handleXSourcePHeader = (headers: HttpHeaders) => {
  return headers.append('x-source-p', environment.xSourceP);
};

const getDid = () => {
  const generalService = inject(GeneralService);
  if (generalService.isBrowserOnly) {
    return localStorage.getItem(variables.did);
  }
  return null;
};

const getAtk = () => {
  const tokenService = inject(TokenService);
  return tokenService.getAtk();
};

const getRtk = () => {
  const tokenService = inject(TokenService);
  return tokenService.getRtk();
};

const getTmt = () => {
  const tokenService = inject(TokenService);
  return tokenService.getTmt();
};

const handleDidHeader = (headers: HttpHeaders) => {
  const did = getDid();
  if (did) {
    headers = headers.append('did', did);
  }
  return headers;
};

const handleAccessTokenHeader = (headers: HttpHeaders) => {
  const did = getDid();
  const atk = getAtk();
  const rtk = getRtk();
  if (rtk) {
    headers = headers.append('atk', atk && did ? atk : 'null');
  }
  return headers;
};

const handleRefreshTokenHeader = (req: HttpRequest<any>, headers: HttpHeaders) => {
  if (
    [
      'refreshToken',
      'logout',
      'getDevices',
      'updateProfile',
      'createProfile',
      'deleteProfile',
      'confirmParentalCode',
      'selectProfile',
      'terminateDevice',
    ].includes(req?.body?.operationName)
  ) {
    const rtk = getRtk();
    if (rtk) {
      headers = headers.append('rtk', rtk);
    }
  }
  return headers;
};

const handleTmtTokenHeader = (req: HttpRequest<any>, headers: HttpHeaders) => {
  if (['getAllDevices', 'terminateDeviceTmt'].includes(req?.body?.operationName)) {
    const tmt = getTmt();
    if (tmt) {
      headers = headers.append('tmt', tmt);
    }
  }
  return headers;
};
